import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type IconLinkProps = IconComponentBaseProps;

export const IconLink = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
  style,
}: IconLinkProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <mask
        id="mask0_4486_102392"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4486_102392)">
        <path
          d="M3.51925 8.26897C2.89142 8.26897 2.35625 8.04772 1.91375 7.60522C1.47125 7.1628 1.25 6.62772 1.25 5.99997C1.25 5.37222 1.47125 4.83705 1.91375 4.39447C2.35625 3.9518 2.89142 3.73047 3.51925 3.73047H5.02888C5.13513 3.73047 5.22417 3.76643 5.296 3.83834C5.36792 3.91026 5.40387 3.99938 5.40387 4.10572C5.40387 4.21197 5.36792 4.30101 5.296 4.37284C5.22417 4.44459 5.13513 4.48047 5.02888 4.48047H3.51863C3.09913 4.48047 2.74117 4.62872 2.44475 4.92522C2.14825 5.22172 2 5.57989 2 5.99972C2 6.41955 2.14825 6.77772 2.44475 7.07422C2.74117 7.37072 3.09913 7.51897 3.51863 7.51897H5.02888C5.13513 7.51897 5.22417 7.55493 5.296 7.62684C5.36792 7.69876 5.40387 7.78784 5.40387 7.89409C5.40387 8.00043 5.36792 8.08947 5.296 8.16122C5.22417 8.23305 5.13513 8.26897 5.02888 8.26897H3.51925ZM4.5 6.37472C4.39375 6.37472 4.30471 6.33876 4.23288 6.26684C4.16096 6.19493 4.125 6.10584 4.125 5.99959C4.125 5.89326 4.16096 5.80422 4.23288 5.73247C4.30471 5.66063 4.39375 5.62472 4.5 5.62472H7.5C7.60625 5.62472 7.69529 5.66068 7.76713 5.73259C7.83904 5.80451 7.875 5.89359 7.875 5.99984C7.875 6.10618 7.83904 6.19522 7.76713 6.26697C7.69529 6.3388 7.60625 6.37472 7.5 6.37472H4.5ZM6.97113 8.26897C6.86488 8.26897 6.77583 8.23301 6.704 8.16109C6.63208 8.08918 6.59613 8.00005 6.59613 7.89372C6.59613 7.78747 6.63208 7.69843 6.704 7.62659C6.77583 7.55484 6.86488 7.51897 6.97113 7.51897H8.48138C8.90088 7.51897 9.25883 7.37072 9.55525 7.07422C9.85175 6.77772 10 6.41955 10 5.99972C10 5.57989 9.85175 5.22172 9.55525 4.92522C9.25883 4.62872 8.90088 4.48047 8.48138 4.48047H6.97113C6.86488 4.48047 6.77583 4.44451 6.704 4.37259C6.63208 4.30068 6.59613 4.21159 6.59613 4.10534C6.59613 3.99901 6.63208 3.90997 6.704 3.83822C6.77583 3.76639 6.86488 3.73047 6.97113 3.73047H8.48075C9.10858 3.73047 9.64375 3.95172 10.0863 4.39422C10.5288 4.83664 10.75 5.37172 10.75 5.99947C10.75 6.62722 10.5288 7.16239 10.0863 7.60497C9.64375 8.04764 9.10858 8.26897 8.48075 8.26897H6.97113Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
